export function openBooking(businessId, tireSize, serviceId) {
  return window.openBooking?.(businessId, tireSize, serviceId);
}
